import { Client } from "@/types"

import { ClientsTableHeader } from "."

export function sortClientsListColumn(column: ClientsTableHeader, isSortedDesc: boolean) {
  const returnValue = isSortedDesc ? -1 : 1

  switch (column) {
    case "ordinal":
      return null

    case "name":
      return () => (a: Client, b: Client) => {
        return a.name.localeCompare(b.name, "pl") * returnValue
      }

    case "phone":
      return () => (a: Client, b: Client) => {
        return a.phone.localeCompare(b.phone, "pl") * returnValue
      }

    case "address":
      return () => (a: Client, b: Client) => {
        return (a.address || "").localeCompare(b.address || "", "pl") * returnValue
      }

    case "deligoo_max_distance_limit":
      return () => (a: Client, b: Client) => {
        return (a.deligoo_max_distance_limit - b.deligoo_max_distance_limit) * returnValue
      }

    case "orders_unsettled_count":
      return () => (a: Client, b: Client) => {
        return (a.orders_unsettled_count - b.orders_unsettled_count) * returnValue
      }
  }
}
